import { useMemo } from 'react'
import { Box } from '@mui/material'

import { IImpact } from 'src/types'
import {
  FairtradeImpactCard,
  FairtradeImpactTitle,
  FairtradeDescriptionWrapper,
  FairtradeImpactAvatar,
  FairtradeDetailsRow,
  FairtradeQuantityBox,
  FairtradeQuantityValue,
  FairtradeQuantityLabel,
  FairtradeMediaWrapper,
  FairtradeBottomSection,
  FairtradeMetaActions,
  ImpactsWrapper,
} from './impacts.styled'
import { QuillHtmlParser } from 'src/components/quill-html-parser'
import { ImageCarousel } from 'src/components/image-carousel'
import { LikesCounter } from 'src/components/impacts-cards-ver/likes-counter.component'
import { BlockchainVerifiedBanner } from 'src/components/blockchain-verified-banner'
import { LatestBlockchainTransactions } from 'src/components/latest-blockchain-transactions'
import { UnSdgList } from 'src/components/impacts-cards-ver/un-sdg-list.component'
import { MediaList } from 'src/components/media-list'
// import { WorldHeartIcon } from 'src/assets/icons/v2/WorldHeartIcon'
import { AIGeneratedBanner } from 'src/components/ai-generated-banner'
import { FairtradeFonts } from '../fairtrade-fonts'
import { PageWrapper } from '../fairtrade.styled'
import { DescriptionPreview } from 'src/components'
import { FAIRTRADE_SKY_BLUE } from '../constants'

interface IProps {
  items: IImpact[]
  showUnSdg: boolean
  primaryColor: string | null
  walletAddress: string
  showWalletAddress: boolean
  showBcInfo: boolean
  showLatestBcOnImpacts: boolean
  accountImage: string | null
  productName?: string
}

export const FairtradeImpactsTemplate = ({
  items,
  showUnSdg,
  primaryColor,
  walletAddress,
  showWalletAddress,
  showBcInfo,
  showLatestBcOnImpacts,
  accountImage,
}: IProps) => {
  // const theme = useTheme()

  const impactsToShow = useMemo(() => items ?? [], [items])

  if (!impactsToShow.length) {
    return null
  }

  return (
    <PageWrapper
      id="index__templates-fairtrade-impacts__pagewrapper__l61"
      sx={{
        pt: '75px',
        gap: '18px',
      }}
    >
      <FairtradeFonts />


      {/* <PageTitle
        id="index__templates-fairtrade-impacts__pagetitle__l68"
        sx={{
          marginX: {
            xs: '24px',
            md: '8px',
          },
        }}
      >
        {t('impacts-header-title')}
      </PageTitle> */}

      <ImpactsWrapper
        id="index__templates-fairtrade-impacts__impactswrapper__l79"
        sx={{
          mx: {
            xs: '6px',
            md: '0px',
          },
        }}
      >
        {impactsToShow.map((impact, index) => {
          const impactIcon = impact.image_medium || impact.image
          const hasImpactIcon = !!impactIcon && !impactIcon.includes('ui-avatars.com/api')
          const mainMedia = impact.mainMedia?.length ? impact.mainMedia : []
          const attachments =
            impact.media?.filter(
              (mediaItem) => !mainMedia.some((main) => main.id === mediaItem.id),
            ) ?? []
          const attachmentsCount = attachments.length

          return (
            <FairtradeImpactCard key={impact.id} id={impact.id} isOdd={index % 2 === 0}>
              <FairtradeImpactTitle id="index__templates-fairtrade-impacts__fairtradeimpacttitle__l92">
                {impact.name}
              </FairtradeImpactTitle>

              {(impact.quantity || impact.quantity_type_name || impact.custom_quantity_type) && (
                <Box
                  id="index__templates-fairtrade-impacts__box__l134"
                  sx={{
                    // marginTop: '10px',
                    marginBottom: '16px',
                  }}
                >
                  <FairtradeQuantityBox id="index__templates-fairtrade-impacts__fairtradequantitybox__l140">
                    <FairtradeQuantityValue id="index__templates-fairtrade-impacts__fairtradequantityvalue__l141">
                      {impact.quantity}
                    </FairtradeQuantityValue>
                    <FairtradeQuantityLabel id="index__templates-fairtrade-impacts__fairtradequantitylabel__l142">
                      {impact.quantity_type_name || impact.custom_quantity_type}
                    </FairtradeQuantityLabel>
                  </FairtradeQuantityBox>
                </Box>
              )}

              <FairtradeDescriptionWrapper id="index__templates-fairtrade-impacts__fairtradedescriptionwrapper__l93">
                {impact.description && impact.description !== '<p><br></p>' ? (
                  <DescriptionPreview
                    contentKey={`impact-description-${impact.id}`}
                    toggleColor={FAIRTRADE_SKY_BLUE}
                    collapsedHeight={320}
                  >
                    <>
                      {hasImpactIcon && (
                        <FairtradeImpactAvatar
                          id="index__templates-fairtrade-impacts__fairtradeimpactavatar__l95"
                          src={impactIcon}
                          alt={impact.name}
                        />
                      )}
                      <QuillHtmlParser
                        html={impact.description}
                        fontSize="20px"
                        // sx={{
                        //   '& p': {
                        //     marginBottom: theme.spacing(2),
                        //   },
                        // }}
                      />
                    </>
                  </DescriptionPreview>
                ) : (
                  hasImpactIcon && (
                    <FairtradeImpactAvatar
                      id="index__templates-fairtrade-impacts__fairtradeimpactavatar__l95"
                      src={impactIcon}
                      alt={impact.name}
                    />
                  )
                )}
              </FairtradeDescriptionWrapper>

              {mainMedia.length > 0 && (
                <FairtradeMediaWrapper id="index__templates-fairtrade-impacts__fairtrademediawrapper__l148">
                  <ImageCarousel images={mainMedia} isStep />
                </FairtradeMediaWrapper>
              )}

              <FairtradeDetailsRow id="index__templates-fairtrade-impacts__fairtradedetailsrow__l153">
                {showUnSdg && !!impact.un_sdg?.length ? (
                  <UnSdgList unSdg={impact.un_sdg} />
                ) : (
                  <Box id="index__templates-fairtrade-impacts__box__l157" />
                )}

                <FairtradeMetaActions id="index__templates-fairtrade-impacts__fairtrademetaactions__l160">
                  <LikesCounter
                    count={impact.totalLikes}
                    userLiked={impact.liked}
                    impactId={impact.id}
                  />
                </FairtradeMetaActions>
              </FairtradeDetailsRow>

              {attachmentsCount > 0 && (
                <FairtradeBottomSection id="index__templates-fairtrade-impacts__fairtradebottomsection__l169">
                  <MediaList media={attachments} />
                </FairtradeBottomSection>
              )}

              {showBcInfo && showLatestBcOnImpacts && impact.scans && impact.scans.length > 0 && (
                <FairtradeBottomSection>
                  <Box sx={{ px: '12px' }}>
                    <LatestBlockchainTransactions
                      scans={impact.scans}
                      primaryColor={primaryColor || undefined}
                      walletAddress={walletAddress}
                      showWalletAddress={showWalletAddress}
                      accountImage={accountImage || undefined}
                      scanImage={impactIcon}
                      scanName={impact.name}
                    />
                  </Box>
                </FairtradeBottomSection>
              )}

              {showBcInfo && impact.scans && impact.scans.length > 0 && (
                <BlockchainVerifiedBanner
                  size={44}
                  scans={impact.scans}
                  stroke={primaryColor || undefined}
                  walletAddress={walletAddress}
                  showWalletAddress={showWalletAddress}
                  impactImage={impact.image}
                  impactName={impact.name}
                  accountImage={accountImage}
                  sx={{
                    top: 'auto',
                    left: 'auto',
                    right: {
                      xs: -8,
                      md: -16,
                    },
                    bottom: {
                      xs: -8,
                      md: -16,
                    },
                  }}
                />
              )}

              {impact.ai_generated && (
                <Box id="index__templates-fairtrade-impacts__box__l193" sx={{ mb: 2 }}>
                  <AIGeneratedBanner
                    sx={{
                      top: 'auto',
                      bottom: 0,
                    }}
                  />
                </Box>
              )}
            </FairtradeImpactCard>
          )
        })}
      </ImpactsWrapper>
    </PageWrapper>
  )
}
